import { render, staticRenderFns } from "./OpenShop.vue?vue&type=template&id=a550e59a&scoped=true"
import script from "./OpenShop.vue?vue&type=script&lang=js"
export * from "./OpenShop.vue?vue&type=script&lang=js"
import style0 from "./OpenShop.vue?vue&type=style&index=0&id=a550e59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550e59a",
  null
  
)

export default component.exports